



















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
// Import FilePond
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';
import { isString } from 'lodash';

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginFilePoster,
);

@Component({
  name: 'bpc-filepond',
  components: {
    FilePond,
  },
})
export default class CustomFilepond extends Vue {
  // PROPS
  @Prop({
    type: Array,
    default: () => {
      return ['image/jpeg', 'image/png'];
    },
  })
  readonly acceptedFileTypes: string[];
  @Prop({ type: Boolean, default: true }) readonly instantUpload: boolean;
  @Prop({ type: Boolean, default: false }) readonly allowRevert: boolean;
  @Prop({ type: Object, default: null }) readonly currentFile: object; // the object has to contain "id" and "url"
  @Prop({ type: String, default: 'global.media.upload.label' }) readonly labelIdle: string;
  @Prop({ type: String, default: 'global.media.loading.label' }) readonly labelFileLoading: string;
  @Prop({ type: String, default: 'global.media.uploading.label' })
  readonly labelFileProcessing: string;
  @Prop({ type: String, default: '' }) readonly labelTapToCancel: string;
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop(String) readonly mediaCollectionName: string;
  @Prop(String) readonly uploadUrl: string;
  @Prop(String) readonly deleteUrl: string;
  /* Lifecycle hooks */
  // created() {}
  mounted() {
    if (this.currentFile && this.currentFile['id'] && this.currentFile['url']) {
      this.setCurrentFile(this.currentFile['id'], this.currentFile['url']);
    }
  }
  // updated () { }
  // destroyed () { }
  // DATA
  files = [];
  server = {
    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
      // fieldName is the name of the input field, but we need to set the collection name where we want to save the file.
      // file is the actual file object to send
      const formData = new FormData();
      formData.append(this.mediaCollectionName, file);

      const uploadUrl = this.uploadUrl
        ? this.uploadUrl
        : this.$bpcApiRouteHelper.getMediaFileUploadEntityPath(this.entity, this.entityId);

      this.$bpcApi.postWithMedia(uploadUrl, formData).subscribe(
        res => {
          this.setCurrentFile(res.data[0].id, res.data[0].url);
          this.$emit('file-uploaded', { id: res.data[0].id, url: res.data[0].url });
          load();
        },
        err => {
          error();
        },
      );
    },
    fetch: null,
    load: (fileSrc, load) => {
      // fileSrc has to be an url
      if (isString(fileSrc)) {
        fetch(fileSrc)
          .then(res => res.blob())
          .then(load);
      }
    },
    remove: (source, load, error) => {
      if (this.currentFileId) {
        const deleteUrl = this.deleteUrl
          ? this.deleteUrl
          : this.$bpcApiRouteHelper.getMediaFileDeleteEntityPath(
              this.entity,
              this.entityId,
              this.currentFileId,
            );

        this.$bpcApi.delete(deleteUrl).subscribe(
          res => {
            this.$emit('file-removed');
            load();
          },
          err => {
            error();
          },
          () => {
            this.files = [];
          },
        );
      } else {
        this.files = [];
        load();
      }
    },
  };
  // COMPUTED
  get currentFileId() {
    return this.currentFile['id'];
  }
  // METHODS
  setCurrentFile(id, url) {
    this.files = [
      {
        source: url,
        // set type to local to indicate an already uploaded file
        options: {
          type: 'local',
          metadata: {
            id: id,
          },
        },
      },
    ];
  }
  // WATCHERS
}
